import footerBgWEBP from '../../images/store/footer-bg.webp';
import dividerPNG from '../../images/store/divider.png';
import reasonLogoPNG from '../../images/store/reason-logo.png';
import { Link } from '../Link';

export default function ReasonFooter() {
  return (
    <footer className="footer text-muted">
      <img className="footer-image" src={footerBgWEBP} alt="footer-image" />
      <div className="container">
        <img className="container mx-auto divider" src={dividerPNG} alt="divider image" />

        <div className="row mt-5">
          <div className="col-md-2">
            <img src={reasonLogoPNG} alt="logo" className="w-75 mx-auto footer-logo" />
          </div>
          <div className="col-md-4" style={{ marginBottom: '20px' }}>
            <div className="logo" />
            <p className="copyright">
              Trademarks and brands are the property of their respective owners.
              TreasonPs is not affiliated with Jagex or RuneScape. To play RuneScape, visit{' '}
              <a href="https://runescape.com" target="_blank" rel="noreferrer">
                runescape.com
              </a>
            </p>
            <p className="copyright">
              Copyright &copy; 2021 TreasonPs | All rights reserved.
            </p>
          </div>
          <div className="col-md-2 bottom-nav-text">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/vote">Vote</Link></li>
              <li><Link to="/hiscores">hiscores</Link></li>
            </ul>
          </div>
          <div className="col-md-2 bottom-nav-text">
            <h4>Articles</h4>
            <ul>
              <li><a href="#">News</a></li>
              <li><a href="#">Updates</a></li>
              <li><a href="#">Guides</a></li>
            </ul>
          </div>
          <div className="col-md-2 bottom-nav-text">
            <h4>Support</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms and Conditions</Link></li>
              <li><Link to="/contact">Report an Issue</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
